import { gql, InternalRefetchQueriesInclude, useMutation } from '@apollo/client'

const doc = gql`
  mutation StoreOrderReadyForPickup($storeOrderId: String!, $notes: String!, $sendEmail: Boolean!) {
    storeOrderReadyForPickup(storeOrderId: $storeOrderId, notes: $notes, sendEmail: $sendEmail)
  }
`

type Vars = {
  storeOrderId: string
  notes: string
  sendEmail: boolean
}

type Data = {
  storeOrderReadyForPickup: boolean
}

const useStoreOrderReadyForPickup = (refetchQueries?: InternalRefetchQueriesInclude) =>
  useMutation<Data, Vars>(doc, { refetchQueries })

export default useStoreOrderReadyForPickup
